// work-orders-routes.ts
export const workOrdersRoutes = [
    {
        path: 'work-orders',
        children: [
            {
                path: 'list',
                lazy: async () => ({
                    Component: (await import('@/pages/work-orders/index')).default,
                }),
            },
            {
                path: ':id',
                lazy: async () => ({
                    Component: (await import('@/pages/work-orders/details')).default,
                }),
            },
            {
                path: 'reports',
                lazy: async () => ({
                    Component: (await import('@/pages/work-orders/reports')).default,
                }),
            },
            {
                path: 'settings',
                lazy: async () => ({
                    Component: (await import('@/pages/work-orders/settings')).default,
                }),
            },
        ],
    },
]